import VerticalNavigation from './VerticalNavigation'

export default VerticalNavigation
// eslint-disable-next-line import/export
export * from './VerticalNavigation'
